module.exports = __webpack_public_path__ + "media/images/homepage/path-1a913004e4cbca647114cc6546fecb9d.png";